import { type MCPServerInfo } from '../../types';

const CheckmarxServer: MCPServerInfo = {
  serverId: 'CHECKMARX',
  name: 'Checkmarx',
  slug: 'checkmarx',
  description:
    'Access Checkmarx One SAST, SCA, IaC, and API security findings through the official Checkmarx MCP server.',
  source: {
    sourceType: 'DYNAMIC_REMOTE_URL',
    mcpServerUrl: 'https://{checkmarxBaseUrl}/api/security-mcp/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['checkmarxBaseUrl', 'apiKey'],
    properties: {
      checkmarxBaseUrl: {
        type: 'string',
        description:
          'Checkmarx One base URL host (e.g. ast.checkmarx.net or eu.ast.checkmarx.net)',
        sensitive: false,
        default: 'ast.checkmarx.net',
        isUrlParameter: true
      },
      apiKey: {
        type: 'string',
        description: 'Checkmarx One API key',
        sensitive: true
      }
    }
  }
};

export default CheckmarxServer;
